import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import VaccinationAndMedication from '../../components/VaccinationAndMedication';

import { Tabs, Tab, Grid, Typography, Container } from '@material-ui/core';

import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { getDefaultAnimalTypeByFarmType } from '../../utils';
import useAuthContext from '../../hooks/useAuthContext';

const OperationalStrategy: React.FC = () => {
  const { area, option } = useParams<{ area: string; option: string }>();
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useAuthContext();

  const [tab, setTab] = React.useState(0);

  const handleTabChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate(`/strategy/injections/${option}`);
        break;
      case 1:
        navigate('/strategy/staff');
        break;
      case 2:
        navigate('/strategy/tasks');
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (area && area === 'injections') {
      setTab(0);
      return;
    }
    if (area && area === 'staff') {
      setTab(1);
      return;
    }
    if (area && area === 'tasks') {
      setTab(2);
      return;
    }
  }, [area]);

  const convertOptionToAnimalType = () => {
    const animalTypeNumber = Number(option);

    if (animalTypeNumber > 0) {
      return animalTypeNumber;
    } else if (animalTypeNumber === 0) {
      const defaultAnimalType = getDefaultAnimalTypeByFarmType(state.farmType);
      return defaultAnimalType;
    }
  };

  return (
    <Container maxWidth="lg">
      <Grid container>
        <Grid item xs={12} md={12}>
          <Grid container alignItems="center">
            <Grid item>
              <TrendingUpIcon fontSize="large" color="primary" />
            </Grid>
            <Grid item className={classes.pl1}>
              <Typography component="h2" variant="h6" color="primary">
                {t('f-strategy')}
              </Typography>
            </Grid>
          </Grid>

          {/* todo: Fix scroll of tabs on small screens */}
          <Grid container direction="column" className={classes.mt1}>
            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
              <Tab label={t('f-strat-treat')} />
              <Tab label={t('f-strat-staff')} disabled />
              <Tab label={t('f-strat-tasks')} disabled />
            </Tabs>
          </Grid>

          <Grid container className={classes.mt2}>
            {tab === 0 && (
              <Grid item xs={12} md={12}>
                <VaccinationAndMedication animalType={convertOptionToAnimalType()} />
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12} md={12}>
                {'Staff Assignment - coming soon!'}
              </Grid>
            )}
            {tab === 2 && (
              <Grid item xs={12} md={12}>
                {'Task Routines - coming soon!'}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default OperationalStrategy;
